import React from 'react';
import { Tree } from 'primereact/tree';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';
import DOMPurify from 'dompurify';

const NodeTree = ({
  nodes,
  selectedNode,
  setSelectedNode,
  expandedKeys,
  setExpandedKeys,
  pathNodes,
  setPathNodes,
  showDialog,
  setShowDialog,
  setDialogType,
  setQuestion,
  setResponse,
  updateNode,
  addChildNode,
  removeNode,
  findParent,
  menuRefs,
  toast,
  setNodes,
  currentNode
}) => {
  const nodeTemplate = (node) => {
    const depth = node.key.split('-').length - 1;
    const canAddChild = depth < 5;
    const isRoot = node.key === '0';
    const isCurrentNode = currentNode?.key === node.key;
    const isPathNode = pathNodes.has(node.key);
    const isEdited = node.data.isEdited;

    const confirmDelete = () => {
      if (node.children?.length > 0) {
        confirmDialog({
          message: 'Are you sure you want to delete this message? This will also remove all its child messages.',
          header: 'Delete Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            setNodes(removeNode(nodes, node.key));
            toast.current?.show({
              severity: 'success',
              summary: 'Deleted',
              detail: 'Message and its children have been deleted successfully'
            });
          }
        });
      } else {
        setNodes(removeNode(nodes, node.key));
        toast.current?.show({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Message has been deleted successfully'
        });
      }
    };

    const menuItems = [
      canAddChild && {
        label: 'Add Child',
        icon: 'pi pi-plus',
        command: () => {
          setDialogType('add');
          setSelectedNode(node);
          setQuestion('');
          setResponse('');
          setShowDialog(1);
        }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          setDialogType('edit');
          setSelectedNode(node);
          setQuestion(node.data.question);
          setResponse(isRoot ? '' : node.data.response);
          setShowDialog(2);
        }
      },
      !isRoot && {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: confirmDelete
      }
    ].filter(Boolean);

    if (!menuRefs.current[node.key]) {
      menuRefs.current[node.key] = React.createRef();
    }

    return (
      <div
        className={`node-content ${isCurrentNode ? 'current-node' : ''} ${isPathNode ? 'path-node' : ''} ${isEdited ? 'edited-node' : ''}`}
        onClick={(e) => {
          if (menuItems.length > 0) {
            e.stopPropagation();
          }
        }}
      >
        <span>{DOMPurify.sanitize(node.data.question, { ALLOWED_TAGS: [] })}</span>
        
        {menuItems.length > 0 && (
          <Button
            icon="pi pi-ellipsis-v"
            className="p-button-text p-button-rounded"
            onClick={(e) => {
              e.stopPropagation();
              menuRefs.current[node.key].current.toggle(e);
            }}
            aria-controls={`menu-${node.key}`}
            aria-haspopup
          />
        )}
        <Menu
          ref={menuRefs.current[node.key]}
          popup
          model={menuItems}
          id={`menu-${node.key}`}
        />
      </div>
    );
  };

  return (
    <div className="builder-tree">
      <Tree
        value={nodes}
        nodeTemplate={nodeTemplate}
        selectionMode="single"
        onSelect={(e) => setSelectedNode(e.node)}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
      />
    </div>
  );
};

export default NodeTree; 